import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

class VoyageSummarySvc {
  constructor() {
    this.api = axiosInstance.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
  }

  /**
   * GET `/voyage/summary/{mvygId}` — satu request, summary voyage langsung jadi.
   * SUDAH di-unwrap: yang balik `res.data.data.summary`.
   *
   * Gagal dibalikin HTTP 200 + envelope error (`status.error` bukan nol), bukan lewat
   * catch axios — makanya dicek manual lalu dibungkus jadi Error ber-`errorCode`.
   *
   * Blok yang dibaca src/views/voyage/utils/voyageSummaryModel.js:28:
   * - `navigationMetrics.totalDistance` meter, `navigationMetrics.averageSpeed` km/h
   * - `mainEngineMetrics.averageRpm`, `.totalRunningSeconds` (detik), `.fuelConsEngine`,
   *   `.totalCons` (liter)
   * - `aeMetrics.runningSeconds` (detik), `aeMetrics.fuelConsumption` (liter)
   *
   * Dua jebakan bentuk, dua-duanya udah dijaga di model itu:
   * - key engine di `averageRpm` dan `totalRunningSeconds` HURUF BESAR, sementara key
   *   di `fuelConsEngine` huruf kecil (voyageSummaryModel.js:52)
   * - nilainya bisa datang sebagai string, jadi wajib lewat toNumber yang ngebedain
   *   null dari 0 (voyageSummaryModel.js:4)
   *
   * @param {number|string} mvygId id voyage
   * @returns {Promise<Object>} isi `res.data.data.summary`
   * @throws {Error} ber-property `errorCode` dari `status.errorCode`
   */
  async fetchById(mvygId) {
    try {
      const res = await this.api.get(`/voyage/summary/${mvygId}`, {
        cancelToken: getNewCancelToken(),
      });
      const { status, data } = res.data;

      if (status?.error) {
        throw Object.assign(
          new Error(status.message || 'Failed to fetch voyage summary'),
          { errorCode: status.errorCode },
        );
      }

      return data.summary;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new VoyageSummarySvc();
